import find from 'lodash/find';
import map from 'lodash/map';
import omit from 'lodash/omit';
import Assumption from './Assumption/';
import Boolean from './Boolean/';
import CommentOptions from './CommentOptions';
import Date from './Date/';
import ListMultiSelect from './ListSelect/ListMultiSelect';
// import RichText from './RichText';
import ListSelect from './ListSelect/ListSelect';
import Number from './Number/Number';
import ProjectCalendar from './ProjectCalendar/';
import MultiRelationshipSelect from './RelationshipSelect/';
// import MdTextArea from './MdTextArea';
import String from './String';
// import WBS from './WBS';
import TaskStatus from './TaskStatus/';
import TextArea from './TextArea';
import TimeZone from './TimeZone/';
import Url from './Url';
// import ColorPicker from './ColorPicker';
import UserSelect from './UserSelect/UserSelect';

const required = value => (value ? undefined : 'Required');
const wholeNumber = value =>
  value && /^\d+$/.test(value)
    ? undefined : 'Whole number only'


const components = [
  {
    type: 'String',
    title: 'String',
    option: 'string',
    component: String,
    defaultVal: null,
  },
  {
    type: 'Textarea',
    title: 'Text Area',
    option: 'textarea',
    component: TextArea,
    defaultVal: null,
  },
  // {
  //   type: 'MdTextarea',
  //   title: 'Markdown Text Area',
  //   option: 'mdtextarea',
  //   component: MdTextArea,
  //   defaultVal: null,
  // },
  {
    type: 'Boolean',
    title: 'Boolean',
    option: 'boolean',
    component: Boolean,
    defaultVal: true,
  },
  {
    type: 'Number',
    title: 'Number',
    option: 'number',
    component: Number,
    defaultVal: null,
    validate:[required, wholeNumber]
  },
  {
    type: 'Url',
    title: 'URL',
    option: 'url',
    component: Url,
    defaultVal: null,
  },
  {
    type: 'Date',
    title: 'Date',
    option: 'date',
    component: Date,
    defaultVal: null,
  },
  // {
  //   type: 'RichText',
  //   title: 'Rich Text',
  //   option: 'richtext',
  //   component: RichText,
  //   defaultVal: null,
  // },
  {
    type: 'ListSelect',
    title: 'ListSelect',
    option: 'listselect',
    component: ListSelect,
    defaultVal: null,
  },
  {
    type: 'ListMultiSelect',
    title: 'ListMultiSelect',
    option: 'listmultiselect',
    component: ListMultiSelect,
    defaultVal: null,
  },
  // {
  //   type: 'ColorPicker',
  //   title: 'ColorPicker',
  //   option: 'colorpicker',
  //   component: ColorPicker,
  //   defaultVal: null,
  // },
  // {
  //   type: 'wbs',
  //   title: 'WBS',
  //   option: 'wbs',
  //   component: WBS,
  //   defaultVal: null,
  // },
  {
    type: 'taskstatus',
    title: 'TaskStatus',
    option: 'taskstatus',
    component: TaskStatus,
    defaultVal: null,
  },
  {
    type: 'assumption',
    title: 'Assumption',
    option: 'assumption',
    component: Assumption,
    defaultVal: null,
  },
  {
    type: 'UserSelect',
    title: 'UserSelect',
    option: 'UserSelect',
    component: UserSelect,
    defaultVal: null,
  },
  {
    type: 'RelationshipSelect',
    title: 'Relationship Select',
    option: 'RelationshipSelect',
    component: MultiRelationshipSelect,
    defaultVal: null,
  },
  {
    type: 'TimeZone',
    title: 'Time Zone',
    option: 'timeZone',
    component: TimeZone,
    defaultVal: null,
  },{
    type: 'ProjectCalendar',
    title: 'Project Calendar',
    option: 'projectcalendar',
    component: ProjectCalendar,
    defaultVal: null,
  },
  {
    type: 'CommentOptions',
    title: 'Comments',
    option: 'commentOptions',
    component: CommentOptions,
    defaultVal: null,
  },
];

export const getComponentDefaultValue = type => {
  if (!type) return null;
  const itype =
    type === 'MultiRelationshipSelect' ? 'RelationshipSelect' : type;
  const component = find(
    components,
    t => t.option.toLowerCase() === itype.toLowerCase(),
  );
  return component ? component.defaultVal : null;
};

export const getComponent = type => {
  const itype =
    type === 'MultiRelationshipSelect' ? 'RelationshipSelect' : type;
  const component = find(
    components,
    t => t.option.toLowerCase() === itype.toLowerCase(),
  );
  return component ? component.component : null;
};

export const getValidation = type => {
  const itype =
    type === 'MultiRelationshipSelect' ? 'RelationshipSelect' : type;
  const component = find(
    components,
    t => t.option.toLowerCase() === itype.toLowerCase(),
  );
  return component ? component.validate : null;
};

export const getCustomMetaComponentsList = () => {
  const allowedTypes = ['String', 'Boolean', 'Number', 'Textarea'];
  return components.reduce((comps, comp) => {
    if (allowedTypes.indexOf(comp.type) > -1) {
      comps.push(omit(comp, ['type', 'component']));
    }
    return comps;
  }, []);
};

export const getProjectPropertiesComponentsList = () => {
  const allowedTypes = [
    'String',
    'Boolean',
    'Number',
    'Textarea',
    'Date',
    // 'WBS',
    'TimeZone',
  ];
  return components.reduce((comps, comp) => {
    if (allowedTypes.indexOf(comp.type) > -1) {
      comps.push(omit(comp, ['type', 'component']));
    }
    return comps;
  }, []);
};

export const getComponentsList = () =>
  map(components, comp => omit(comp, ['type', 'component']));



// WEBPACK FOOTER //
// ./src/components/types/Components.js